// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// px2rem 自适应
import 'lib-flexible'
import {
  Button,
  Carousel,
  Menu,
  Drawer,
  Tabs,
  Icon,
  Breadcrumb,
  Affix,
  BackTop,
  Tree,
  Layout,
  Form,
  Cascader,
  Input,
  Radio,
  Select,
  Pagination
} from 'ant-design-vue'
Vue.use(Button)
Vue.use(Carousel)
Vue.use(Menu)
Vue.use(Drawer)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(Breadcrumb)
Vue.use(Affix)
Vue.use(BackTop)
Vue.use(Tree)
Vue.use(Layout)
Vue.use(Form)
Vue.use(Cascader)
Vue.use(Input)
Vue.use(Radio)
Vue.use(Select)
Vue.use(Pagination)

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js